/**
 * Service: ordersApi
 */
angular
  .module('acme.common.service.ordersApi', ['acme.common.factory.QueryStringBuilder', 'acme.common.factory.apiVersion'])
  .service('OrdersApiService', [
    '$http',
    'QueryStringBuilderFactory',
    'ApiVersionFactory',
    function ($http, QueryStringBuilderFactory, ApiVersionFactory) {
      return {
        service: '',

        init: function (endpoint) {
          this.service = endpoint + '/orders';
          this.partners.service = this.service + '/organizations';
          this.booking.service = endpoint + this.booking.service;
          this.willCall.service = endpoint + this.willCall.service;
          this.requests.service = endpoint + '/orderrequest';
          this.requests.items.service = endpoint + '/orderrequest';
          this.requests.items.itemDetails.service = this.requests.items.service;
          this.forms.service = endpoint + '/orderforms';
          this.analytics.service = endpoint + '/orders/sync/resource';
          this.checkout.service = endpoint + '/orders/checkout';
          return this;
        },

        search: function (props) {
          var av = new ApiVersionFactory(),
            q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: [
                  'pageSize',
                  'page',
                  'sortField',
                  'sortDirection',
                  'search',
                  'startDate',
                  'endDate',
                  'orderCategory',
                ],
              },
            });
            q = qs.query;
          }

          // order/summaries
          return $http({
            method: 'get',
            url: av.init({
              version: 'v2',
              url: this.service.substring(0, this.service.length - 1) + '/summaries/search' + q,
            }),
          });
        },

        csv: function (props) {
          var q = '',
            av = new ApiVersionFactory(),
            endpoint = av.init({
              version: 'v2',
              url: this.service.substring(0, this.service.length - 1) + '/summaries/csv',
            });

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: [
                  'pageSize',
                  'page',
                  'sortField',
                  'sortDirection',
                  'search',
                  'startDate',
                  'endDate',
                  'orderCategory',
                ],
              },
            });
            q = qs.query;
          }

          if (props.useForm) {
            var form = $('<form></form>');

            form
              .attr('method', 'post')
              .attr('enctype', 'application/x-www-form-urlencoded')
              .attr('action', endpoint + q);

            form.appendTo('body').submit().remove();
          } else {
            // order/summaries
            return $http({
              method: 'post',
              url: endpoint + q,
            });
          }
        },

        list: function (props) {
          var av = new ApiVersionFactory(),
            q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: [
                  'pageSize',
                  'page',
                  'sortField',
                  'sortDirection',
                  'search',
                  'startDate',
                  'endDate',
                  'orderCategory',
                ],
              },
            });
            q = qs.query;
          }

          // order/summaries
          return $http({
            method: 'get',
            url: av.init({
              version: 'v2',
              url: this.service.substring(0, this.service.length - 1) + '/summaries' + q,
            }),
          });
        },

        detail: function (id) {
          return $http({
            method: 'get',
            url: this.service + '/detail/' + id,
          });
        },

        detailByVoucher: function (props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['voucherNumber', 'organizationId'],
              },
            });
            q = qs.query;
          }

          // orders/voucher
          return $http({
            method: 'get',
            url: this.service + '/voucher' + q,
          });
        },

        transactions: function (id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id + '/transactions',
          });
        },

        formsSummary: function () {
          return $http({
            method: 'get',
            url: 'assets/data/orderFormSummary.json',
          });
        },

        event: function (id) {
          return $http({
            method: 'get',
            url: this.service + '/event/' + id,
          });
        },

        notes: function (props) {
          return $http({
            method: 'post',
            url: this.service + '/' + props.id + '/notes',
            data: {
              notes: props.notes,
            },
          });
        },

        email: function (props) {
          return $http({
            method: 'post',
            url: this.service + '/' + props.id + '/email',
            data: {
              email: props.email,
              preferredLanguage: props.preferredLanguage,
              sendEmail: true,
            },
          });
        },

        voucher: function (props) {
          return $http({
            method: 'post',
            url: this.service + '/' + props.id + '/paymentid',
            data: {
              paymentId: props.paymentId,
            },
          });
        },

        externalReferenceId: function (props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({
              url:
                this.service +
                '/' +
                props.orderId +
                '/events/' +
                props.eventId +
                '/extreferenceid/' +
                props.externalReferenceId,
              version: 'v2',
            }),
          });
        },

        events: function (id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id + '/events',
          });
        },

        calculate: function (props) {
          return $http({
            method: 'post',
            url: this.service + '/update/charges',
            data: {
              orderId: props.orderId,
              accountContactId: props.accountId,
              notes: props.notes,
              orderItems: props.orderItems,
              noEmail: props.noEmail,
              email: props.email,
              contactFirstName: props.contactFirstName,
              contactLastName: props.contactLastName,
              zipCode: props.zipCode,
              phoneNumber: props.phoneNumber,
            },
          });
        },

        update: function (data) {
          return $http({
            method: 'post',
            headers: {
              'x-acme-request-uuid': data.requestUUID,
            },
            url: this.service + '/update',
            data: data,
          });
        },

        validateEntitlements: function (data) {
          return $http({
            method: 'post',
            url: this.service + '/validateEntitlements',
            data: data,
          });
        },

        partners: {
          service: '',

          list: function (props) {
            var url = this.service + '/summaries',
              q = '',
              av = new ApiVersionFactory();

            if (props) {
              var qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: ['page', 'pageSize', 'sortDirection', 'sortField'],
                },
              });

              q = qs.query;
            }

            url = av.init({ url: url, version: 'v2' });

            return $http({
              method: 'get',
              url: url + '/' + props.id + q,
            });
          },

          create: function (data) {
            var url = this.service;
            url += data.accountId ? '/' + data.accountId : '';

            return $http({
              method: 'post',
              headers: {
                'x-acme-request-uuid': data.requestUUID,
              },
              url: url,
              data: data,
            });
          },
        },

        booking: {
          service: '/rebook',

          create: function (data) {
            return $http({
              method: 'post',
              url: this.service + '/orders',
              data: data,
            });
          },

          calculate: function (props) {
            return $http({
              method: 'post',
              url: this.service + '/charges',
              data: {
                orderId: props.orderId,
                notes: props.notes,
                rebookItems: props.rebookItems,
                incidentReasonCode: props.incidentReasonCode,
                eventRebookFeeCounts: props.eventRebookFeeCounts,
              },
            });
          },
        },

        willCall: {
          service: '/willCall/orders',

          find: function (props) {
            var queries = [],
              q = '';

            if (props) {
              if (props.search) {
                queries.push('search=' + props.search);
              }

              if (props.orderNumber) {
                queries.push('orderNumber=' + props.orderNumber);
              }

              if (props.email) {
                queries.push('email=' + props.email);
              }

              if (props.contactName) {
                queries.push('contactName=' + props.contactName);
              }

              if (queries.length > 0) {
                q = '?' + queries.join('&');
              }
            }

            return $http({
              method: 'get',
              url: this.service + q,
            });
          },

          order: function (id) {
            return $http({
              method: 'get',
              url: this.service + '/' + id,
            });
          },
        },

        requests: {
          service: '',

          list: function (props) {
            var q = '',
              av = new ApiVersionFactory(),
              qs;

            if (props) {
              qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: [
                    'pageSize',
                    'page',
                    'sortField',
                    'sortDirection',
                    'search',
                    'userId',
                    'status',
                    'paymentStatus',
                  ],
                },
              });

              q = qs.query;
            }

            return $http({
              method: 'get',
              url: av.init({
                url: this.service + q,
                version: 'v2',
              }),
            });
          },

          detail: function (id) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'get',
              url: av.init({
                url: this.service + '/' + id,
                version: 'v2',
              }),
            });
          },

          create: function (props) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'post',
              data: props,
              url: av.init({
                url: this.service,
                version: 'v2',
              }),
            });
          },

          update: function (props) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'put',
              data: props,
              url: av.init({
                url: this.service,
                version: 'v2',
              }),
            });
          },

          remove: function (props) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'delete',
              data: props,
              url: av.init({
                url: this.service + '/' + props.id,
                version: 'v2',
              }),
            });
          },

          items: {
            service: '',

            detail: function (id, itemId) {
              var av = new ApiVersionFactory();

              return $http({
                method: 'get',
                url: av.init({
                  url: this.service + '/' + id + '/items/' + itemId,
                  version: 'v2',
                }),
              });
            },

            create: function (id, props) {
              var av = new ApiVersionFactory();

              return $http({
                method: 'post',
                data: props,
                url: av.init({
                  url: this.service + '/' + id + '/items',
                  version: 'v2',
                }),
              });
            },

            update: function (id, props) {
              var av = new ApiVersionFactory();

              var data = {
                orderRequestId: props.orderRequestId,
                orderRequestItemId: props.orderRequestItemId,
                eventTemplateId: props.eventTemplateId,
                eventTemplateName: props.eventTemplateName,
                orderRequestItemSummary: props.orderRequestItemSummary,
                orderItemType: props.orderItemType,
                customFields: props.customFields || [],
                externalReferenceId: props.externalReferenceId || '',
              };
              if (props.eventId) {
                data.eventId = props.eventId;
              }
              if (props.eventStartDate) {
                data.eventStartDate = props.eventStartDate;
              }
              if (props.eventName) {
                data.eventName = props.eventName;
              }

              return $http({
                method: 'put',
                data: data,
                url: av.init({
                  url: this.service + '/' + id + '/items',
                  version: 'v2',
                }),
              });
            },

            remove: function (id, itemId) {
              var av = new ApiVersionFactory();

              return $http({
                method: 'delete',
                url: av.init({
                  url: this.service + '/' + id + '/items/' + itemId,
                  version: 'v2',
                }),
              });
            },

            itemDetails: {
              service: '',

              list: function (id, itemId, props) {
                var av = new ApiVersionFactory();

                var q = '',
                  qs;

                if (props) {
                  qs = new QueryStringBuilderFactory({
                    props: props,
                    fields: {
                      optional: ['pageSize', 'page', 'sortField', 'sortDirection'],
                    },
                  });

                  q = qs.query;
                }

                return $http({
                  method: 'get',
                  url: av.init({
                    url: this.service + '/' + id + '/items/' + itemId + '/details' + q,
                    version: 'v2',
                  }),
                });
              },

              create: function (id, itemId, props) {
                var av = new ApiVersionFactory();

                return $http({
                  method: 'post',
                  data: props,
                  url: av.init({
                    url: this.service + '/' + id + '/items/' + itemId + '/details',
                    version: 'v2',
                  }),
                });
              },

              createBulk: function (id, itemId, props) {
                var av = new ApiVersionFactory();

                return $http({
                  method: 'post',
                  data: props,
                  url: av.init({
                    url: this.service + '/' + id + '/items/' + itemId + '/details/bulk',
                    version: 'v2',
                  }),
                });
              },

              remove: function (id, itemId, itemDetailId) {
                var av = new ApiVersionFactory();

                return $http({
                  method: 'delete',
                  url: av.init({
                    url: this.service + '/' + id + '/items/' + itemId + '/details/' + itemDetailId,
                    version: 'v2',
                  }),
                });
              },
            },
          },
        },

        forms: {
          service: '',

          list: function (props) {
            var q = '',
              av = new ApiVersionFactory();

            if (props) {
              var qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: ['pageSize', 'page'],
                },
              });
              q = qs.query;
            }

            return $http({
              method: 'get',
              url: av.init({
                url: this.service + '/orders/' + props.orderId + '/forms/summaries' + q,
                version: 'v2',
              }),
            });
          },
          response: function (props) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'get',
              url: av.init({
                url: this.service + '/orders/' + props.orderId + '/forms/responses/' + props.responseId,
                version: 'v2',
              }),
            });
          },

          responses: {
            customer: function (props, queryParams) {
              return $http({
                method: 'get',
                url: '/v2/api/orderforms/responses/customer/' + props.customerId,
                params: queryParams,
              });
            },

            membership: function (props) {
              return $http({
                method: 'get',
                url: '/v2/api/orderforms/responses/membership/' + props.membershipId,
              });
            },
          },
        },

        analytics: {
          service: '',

          sync: function (props) {
            var q = '',
              av = new ApiVersionFactory();

            return $http({
              method: 'get',
              url: av.init({
                url: this.service + '/' + props.eventId,
                version: 'v2',
              }),
            });
          },
        },

        checkout: {
          service: '',

          /**
           * Get refund charges see on BE ./order/src/main/java/com/acme/order/vo/OrganizationOrderInputVo.java
           * @param {Object} props | OrganizationOrderInput
           * @returns
           */
          charges: function (props) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'post',
              url: av.init({
                url: this.service + '/charges',
                version: 'v2',
              }),
              data: props,
            });
          },

          /**
           * @param {{
           * membershipId: string;
           * saleChannel: 'insideSalesIndividual';
           * paymentMethod: 'Cash';
           * shoppingCart: {
           *   items: object[];
           *   verifyEntitlements: boolean;
           *   membershipCategoryId: string;
           *   membershipId: string;
           *   saleChannel: 'insideSalesIndividual'
           * },
           * notes: string;
           * }} props CheckoutB2BInput
           * @returns {Order}
           */
          cancelAndRefund: function (props) {
            return $http({
              method: 'post',
              url: '/v2/api/checkout',
              data: props,
            });
          },

          /**
           *
           * @param {{
           *  pan: string
           *  phone: string
           *  amount: currency
           *  email: string
           *  firstName: string
           *  lastName: string
           *  streetAddress: string
           *  zipCode: string
           *  city: string
           *  state: string
           *  countryCode: string
           * }} props Checkout3DSVerificationInput
           * @returns {*}
           */
          fraudShieldVerification: function (props) {
            var av = new ApiVersionFactory();
            var q = '';

            if (props) {
              var qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: ['pageSize', 'page'],
                },
              });
              q = qs.query;
            }

            return $http({
              method: 'post',
              url: av.init({
                url: this.service + '/3ds/verification?pageSize=50&page=1' + q,
                version: 'v2',
              }),
              data: props,
            });
          },
        },
      };
    },
  ]);
